import { stopAll, type StopHandle } from '@/util/stopHandle';
import { watchImmediate } from '@vueuse/core';
import { useDeveloperSettings } from '@/stores/developerSettings';
import type { PlannerStore } from '@/views/3d-planner/store/plannerStore';
import type { PlannerSceneViewModel } from '@/views/3d-planner/store/plannerSceneViewModel.types';

/** Scene updates that are not specific to the components. Reads domain off the Model, scene off the VM. */
export function updatePlanner(model: PlannerStore, scene: PlannerSceneViewModel): StopHandle {
    const settings = useDeveloperSettings();

    return stopAll(
        watchImmediate(
            () => scene.visibility.xray,
            (value) => (scene.renderingMode = value === 'on' ? 'xray' : 'normal'),
        ),
        // Note: planner-mode → camera-placement reorient lives in
        // useActivePresetTracker (which owns the Default-preset highlight).
        watchImmediate(
            () => model.sceneCentre,
            (centre) => {
                scene.nodes.sceneCentre.transform.setPosition(centre);
                scene.nodes.sceneGrid.transform.setPosition(centre);
            },
        ),
        watchImmediate(
            () => settings.animateCameras !== false && !model.isLoading,
            (value) => (scene.rendering.camera.animate = value ?? false),
        ),
        watchImmediate(
            () => settings.show3dFeatures ?? false,
            (show) => {
                [scene.nodes.sceneCentre, scene.nodes.sceneGrid, scene.nodes.ctOrigin].forEach(
                    (node) => (node.visible = show),
                );
            },
        ),
    );
}
